var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="dotchart--'+
((__t=( className ))==null?'':__t)+
'"> <label class="dotchart--label dotchart--label_left">0%</label> <label class="dotchart--label dotchart--label_right">100%</label> <div class="dotchart--baseline"></div> ';
 dots.forEach(function(dot) { 
__p+=' ';
 if(dot[0].className == 'highlight') { 
__p+=' <span class="dot '+
((__t=( dot[0].className ))==null?'':__t)+
'" data-val="'+
((__t=( dot[0].t ))==null?'':__t)+
'" style="left: '+
((__t=( +dot[0].t ))==null?'':__t)+
'%"> '+
((__t=( dot[0].rank ))==null?'':__t)+
' </span> ';
 } else { 
__p+=' <span class="dot '+
((__t=( dot[0].className ))==null?'':__t)+
'" data-val="'+
((__t=( dot[0].t ))==null?'':__t)+
'" style="left: '+
((__t=( +dot[0].t ))==null?'':__t)+
'%"> </span> ';
 }}); 
__p+=' <label class="dotchart--label dotchart--label_highlight" style="left: '+
((__t=( highlight.t ))==null?'':__t)+
'%"> <span class="collecticon collecticon-arrow-down"></span> </label> <div class="dotchart--tooltip off-screen"> </div> </div>';
}
return __p;
};
